
export const TOAST_TYPES = {
    DANGER: 'danger',
    WARN: 'warning',
    SUCCESS: 'success',
    INFO: 'info'
};

export const AGE_GROUPS = [
    '8-12 Years old',
    '13-18 Years old',
    'All ages'
];

export const AGE_GROUPS_MAPPING = {
    '8-12 Years old': '8_12',
    '13-18 Years old': '13_18',
    'All ages': '8_18',
};

export const GLOBAL_COUNTRY_CODE = "_GLB"

export const METADATA_KEY = {
    GOAL_CHART: 'DG Name',
    COMPETENCIES_CHART: 'IndexL8 (Item)',
    CPCI_TABLE: 'IndexL2 (Name)',
    TARGET_TABLE: 'IndexL4 (Name)',
}

export const GRADE_COLOR_MAPPING = {
    A: '#03AF9A',
    B: '#8269D2',
    C: '#EBB941',
    D: '#F05E63',
    E: '#003C69',
    NA: '#003C69'
}

export const GOAL_COLOR_MAPPING = {
    "P1.IndiSkill": "#003C69",
    "P1.IndiUse": "#00AF9B",
    "P1.Fam": "#F05F64",
    "P1.Sch": "#BE64C3",
    "P1.DESG": "#8269D2",
    "P1.Soft": "#007DB4",
    "P1.Hard": "#EBB941",
    "P1.GCCR": "#003C69",
};

export const STAKEHOLDERS_CATEGORY_COLOR_MAPPING = {
    "Empowered Children": "#003C69",
    "Safe Technology": "#007DB4",
    "Protective Policies": "#0096C8",
};

export const DEFAULT_COUNTRIES = {
    SG: { code: 'SG', label: 'Singapore' },
    AU: { code: 'AU', label: 'Australia' },
}